export default __webpack_public_path__ + "static/media/banner 2.d5cba090.png";